import React from "react";

import * as S from './CardCertifications.styles'

import { Heading, Paragraph } from '../../atoms/Typography/Typography.component'

const CardCertifications = ({ title, certification, parentColorScheme, withBackground }) => {
  return (
    <S.CardCertificationsContent colorScheme={parentColorScheme} withBackground={withBackground}>
      <Heading 
        content={title}
        weight={'medium'}
        typo={'headingMD'} 
        as={'h3'}
      />
      <Paragraph
        content={certification}
        weight={'medium'}
        typo={'paragraphMD'}
      />
    </S.CardCertificationsContent>
  )
}

export default CardCertifications